import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

import { LoadingCoordinatorService } from '../../services/loading/loading-coordinator.service';
import { Mat3ButtonComponent } from '../base-components/mat3-button/mat3-button.component';

@Component({
  selector: 'app-404',
  imports: [RouterModule, Mat3ButtonComponent, TranslatePipe],
  templateUrl: './404.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App404Component implements OnInit {
  private loadingCoordinator = inject(LoadingCoordinatorService);

  ngOnInit(): void {
    this.loadingCoordinator.setGuardsComplete(true);
    this.loadingCoordinator.setPublicPageRendered();
  }
}
